import {
    AppBar,
    Toolbar,
    Typography,
    IconButton,
    Drawer,
  } from "@mui/material";
  import { styled } from "@mui/material/styles";
  import MenuIcon from "@mui/icons-material/Menu";
  import React, { useState, useEffect } from "react";
  import LoginLogout from "./LoginLogout"
  
  const StyledAppBar = styled(AppBar)(({ theme }) => ({
    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    paddingRight: "79px",
    paddingLeft: "118px",
    [theme.breakpoints.down('md')]: {
      paddingLeft: 0,
    },
  }));

  const StyledToolbar = styled(Toolbar)({
    display: "flex",
    justifyContent: "space-between",
    minHeight: 64,
  });

  const LogoTypography = styled(Typography)(({ theme }) => ({
    fontFamily: "Work Sans, sans-serif",
    fontWeight: 700,
    fontSize: '1.5rem',
    color: "#FFFFFF",
    textAlign: "left",
    letterSpacing: '-0.02em',
    textShadow: '0 2px 4px rgba(0,0,0,0.1)',
  }));

  const DrawerContainer = styled('div')({
    padding: "20px 30px",
  });
  
  export default function Header(props) {
  
    const [state, setState] = useState({
      mobileView: false,
      drawerOpen: false
    });

    const { mobileView, drawerOpen } = state;

    useEffect(() => {
      const setResponsiveness = () => {
        return window.innerWidth < 900
          ? setState((prevState) => ({ ...prevState, mobileView: true }))
          : setState((prevState) => ({ ...prevState, mobileView: false }));
      };
  
      setResponsiveness();
  
      window.addEventListener("resize", () => setResponsiveness());
  
      return () => {
        window.removeEventListener("resize", () => setResponsiveness());
      };
    }, []);
  
    const displayDesktop = () => {
      return (
        <StyledToolbar>
          {pbLogo}
          <div>{getMenuButtons()}</div>
        </StyledToolbar>
      );
    };
  
    const displayMobile = () => {
      const handleDrawerOpen = () =>
        setState((prevState) => ({ ...prevState, drawerOpen: true }));
      const handleDrawerClose = () =>
        setState((prevState) => ({ ...prevState, drawerOpen: false }));
  
      return (
        <Toolbar>
          <IconButton
            {...{
              edge: "start",
              color: "inherit",
              "aria-label": "menu",
              "aria-haspopup": "true",
              onClick: handleDrawerOpen,
            }}
          >
            <MenuIcon />
          </IconButton>
  
          <Drawer
            {...{
              anchor: "left",
              open: drawerOpen,
              onClose: handleDrawerClose,
            }}
          >
            <DrawerContainer>{getDrawerChoices()}</DrawerContainer>
          </Drawer>
  
          <div>{pbLogo}</div>
        </Toolbar>
      );
    };

    const getDrawerChoices = () => {
      return (
        <LoginLogout />
      );
    };
  
    const pbLogo = (
      <LogoTypography variant="h6" component="h1">
        Pattern Bin
      </LogoTypography>
    );
  
    const getMenuButtons = () => {
      return ;
        //<LoginLogout onLoginSuccessCallback={loginSuccess} onLogoutSuccessCallback={logoutSuccess} loggedIn={userLoggedIn} />
    };
  
    return (
      <header>
        <StyledAppBar>
          {mobileView ? displayMobile() : displayDesktop()}
        </StyledAppBar>
      </header>
    );
  }
  